module.exports = __webpack_public_path__ + "static/media/full-modal-header.bc290191.png";